import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

type CustomerImportConfirmChangesDialogProps = {
  open: boolean;
  isPending: boolean;
  counts: {
    add: number;
    modify: number;
    remove: number;
  };
  onCancel: () => void;
  onConfirm: () => void;
};

function CustomerImportConfirmChangesDialog({
  open,
  isPending,
  counts,
  onCancel,
  onConfirm,
}: CustomerImportConfirmChangesDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Vahvista muutokset</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Yhteenveto valituista muutoksista
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip
              label={`Lisättävät: ${counts.add}`}
              color="success"
            />
            <Chip
              label={`Päivitettävät: ${counts.modify}`}
              color="warning"
            />
            <Chip
              label={`Poistettavat: ${counts.remove}`}
              color="error"
            />
          </Stack>
          <Typography variant="body1">
            Haluatko varmasti suorittaa valitut muutokset?
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Peruuta
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={isPending}
        >
          Kyllä
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomerImportConfirmChangesDialog;
